import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { FileTextOutlined } from '@ant-design/icons';
import PageTransition from '@/components/ui/PageTransition';
import { PageHeader } from '@/components/ui/PageHeader';
import { AdminLogsView, adminLogsSearchSchema, type AdminLogsSearch } from '@/components/logs';

export const Route = createFileRoute('/admin/ai/logs')({
  validateSearch: (search) => adminLogsSearchSchema.parse(search),
  component: AILogsPage
});

/**
 * Platform-wide logs: flow executions across all tenants and the admin audit trail.
 */
function AILogsPage() {
  const { t } = useTranslation('admin');
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  const handleSearchChange = (patch: Partial<AdminLogsSearch>) =>
    navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true });

  return (
    <PageTransition animation="fadeInUp">
      <PageHeader icon={<FileTextOutlined />} title={t('ai.logs.title')} description={t('ai.logs.subtitle')} />

      <AdminLogsView search={search} onSearchChange={handleSearchChange} exportName="platform" />
    </PageTransition>
  );
}
